// @flow

/**
 * pageInfo.js - Редьюсер для изменения информации о странице
 * @module reducers/pageInfo
 * @requires module:constants/PageInfo
 * */

import {LOCATION_CHANGE} from 'react-router-redux'

import {SET_PAGE_INFO} from '../constants/PageInfo'

/**
 * @memberof reducers/pageInfo
 * */
type PageInfo = {
    count: number,
    viewtime: number,
    recirculation: number,
    title: string,
    url: string,
    image: string,
    author?: string,
    description?: string,
    date?: string,
}

/**
 * @memberof reducers/pageInfo
 * */
type State = PageInfo

/**
 * @memberof reducers/pageInfo
 * */
type Action = {
    type: string,
    pageInfo: PageInfo
}

/**
 * Начальное состояние
 * @memberof reducers/pageInfo
 * */
export const initialState: State = {
    count: 0,
    viewtime: 0,
    recirculation: 0,
    title: '',
    url: '',
    image: '',
}

/**
 * Возвращает новое состояние с данными о топе источников
 * @memberof reducers/pageInfo
 * @function pageInfo
 * @param {State} state
 * @param {Action} action
 * @return {State}
 * */
export default function pageInfo(state: State = initialState, action: Action): State {
    switch (action.type) {
        case SET_PAGE_INFO:
            return {...state, ...action.pageInfo}
    
        case LOCATION_CHANGE:
            return {...initialState}

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/pageInfo.js